import { styled } from '@mui/material/styles';

import { Tab } from '@mui/material';

const StyledTab = styled(Tab)(({ theme }) => ({
    flex: 1,
    height: 40,
    minHeight: 32,
    borderRadius: 6,
    fontWeight: 'bold',
    textTransform: 'none',
    color: theme.palette.storeDrawer.tabs.color,
    transition: 'background 0.2s ease',
    '&.Mui-selected': {
        color: theme.palette.primary.contrastText,
    },
}));

export default StyledTab;
